import useSWR from 'swr';
import { analyticsService } from '@/services/analytics-service';

export function useAnalytics() {
  const { data: summary, error: summaryError } = useSWR(
    'analytics/summary',
    () => analyticsService.getSummary()
  );

  const { data: monthlyStats, error: monthlyError } = useSWR(
    'analytics/monthly',
    () => analyticsService.getMonthlyStats()
  );

  const { data: vendorPerformance, error: vendorError } = useSWR(
    'analytics/vendor-performance',
    () => analyticsService.getVendorPerformance()
  );

  return {
    summary,
    monthlyStats,
    vendorPerformance,
    isLoading: !summary && !summaryError || !monthlyStats && !monthlyError || !vendorPerformance && !vendorError,
    error: summaryError || monthlyError || vendorError
  };
}
